import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

export type GetEspLimitsBody = string[]; // array of currencies

export type GetEspLimitsResponse = Record<string, number>; // { CURRENCY: LIMIT }

export const getEspLimits = (builder: WebapiEndpointBuilder) => {
  return builder.query<GetEspLimitsResponse, GetEspLimitsBody>({
    query: (body) => ({
      url: '/user/espLimits',
      method: 'POST',
      body,
    }),
  });
};
